$(function() {

	var RELOAD_DELAY_MILLIS = 10 * 1000;

	var reloadPending = false;

	/**
	 * a server error reloads the page until the error is gone: a terminal at the club comes back by itself. After a
	 * pause, once for all errors meanwhile: a lasting error would reload the page as fast as the server answers. The
	 * frontend's alone - in the backend a list whose data request keeps failing reloaded itself endlessly
	 */
	$(document).ajaxError(function(ev, xhr) {
		if (xhr && xhr.status == 500 && !reloadPending) {
			reloadPending = true;
			window.setTimeout(function() {
				window.location.reload();
			}, RELOAD_DELAY_MILLIS);
		}
	});

});
